import React from 'react';
import { createRoot } from 'react-dom/client';
import AuthWrapper from './AuthWrapper';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

createRoot(document.getElementById('app')).render(
    <QueryClientProvider client={queryClient}>
        <AuthWrapper/>
    </QueryClientProvider>,
);
